
import Vue, { PropType }  from 'vue'
import { CalendarApi, EventApi} from '@fullcalendar/core'

export default Vue.extend({
  name: "custom-event-menu",
  props: {
    thisEvent: Object as PropType<EventApi>,
    jsEvent: Object as PropType<MouseEvent> ,
    calendarAPI: Object as PropType<CalendarApi>,
    facSettings: Object,
  },
  data: function () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      menuWidth: 0,
      menuHeight: 0,
      openTooltip: false
    };
  },
  computed: {
    customMenuPosition(): string  {
      var mousex = this.jsEvent.pageX; //Get X coodrinates
      var mousey = this.jsEvent.pageY; //Get Y coordinates
      //console.log('mousex:' + mousex);
      //console.log('mousey:' + mousey);

      //Distance of element from the right edge of viewport
      let menuVisX = Number(this.windowWidth) - (Number(mousex) + Number(this.menuWidth));
      //Distance of element from the bottom of viewport
      var menuVisY = Number(this.windowHeight) - (Number(mousey) + Number(this.menuHeight));

      if (menuVisX < 20) {
        //If tooltip exceeds the X coordinate of viewport
        mousex = this.jsEvent.pageX - this.menuWidth - 20;
      }
      if (menuVisY < 20) {
        //If tooltip exceeds the Y coordinate of viewport
        mousey = this.jsEvent.pageY - this.menuHeight - 20;
      }

      return "top: " + mousey + "px; left: " + mousex + "px;";
    },    
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    IsActiveEvent() {
      return (this.thisEvent.extendedProps.apptStatus == 0);
    },
    IsNotDayView() {
      return (this.thisEvent.extendedProps.apptStatus == 0);
    },
    onResize() {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
        if (this.$refs.customMenu) {
              let thisCustomMenu = this.$refs.customMenu as HTMLDivElement;
              this.menuWidth = thisCustomMenu.clientWidth; //Find width of tooltip
              this.menuHeight = thisCustomMenu.clientHeight; //Find height of tooltip
        }
    },
    OpenConsultApproval() {
      let consultID = this.thisEvent.id;
      let pid = this.thisEvent.extendedProps.patID;

      let consultURL = `../../../Main/Pages/ConsultApprovalPage.aspx?consult=${consultID}&pid=${pid}`;

      window.open(consultURL, "_blank");
      this.$emit("hideEventMenu");
    },
    PrintTripSheet() {
      window.open(this.thisEvent.extendedProps.tripURL, "_blank");
      this.$emit("hideEventMenu");
    },
    GoToPatientChart() {
      window.open(`PatientChartPage.aspx?pid=${this.thisEvent.extendedProps.patID}&setSelectedTab=Consults`, '_blank');
    },
    OpenTooltipDetails() {
      this.$emit("openTooltipWindow");
    },
    GoToDayView() {
      this.calendarAPI.changeView('agendaDay');
    },
    OpenConsultClaimPopup() {
      this.$emit("openConsultClaim", this.thisEvent)
    }
  },
});
